skyward.base.registerScript('dynamicSectionHeader', function (skyward, $)
{
    "use strict";

    var classes =
    {
        sectionHeader: "sectionHeader",
        dynamicSectionHeader: "sectionHeader--dynamic",
        currentRecordContent: "currentRecordContent",
        informationPopupTabContainer: "informationPopupTabContainer",
        dataObjectViewer: "dataObjectViewer",
        contentArea: "contentArea",
        workflow: "workflow",
        workflowContent: "workflowContent",
        browse: "browse",
        title: "title",
        childRecordQuickEntry:"childrecordquickentry"
    };

    /**
     * Initialize a dynamic section header.
     * It will be added to the top of the content area if a section header doesn't already exist.
     * @this {jQuery}
     */
    function init()
    {
        var dynamicSectionHeader = this;

        var contentAreaDeferred = awaitContentArea(dynamicSectionHeader);

        contentAreaDeferred.done(function (contentArea)
        {
            addSectionHeaderToContentArea(dynamicSectionHeader, contentArea);
        });
    }

    /**
     * Find the nearest element that is a content area.
     * @param {jQuery} element An element to use as a reference point to find the container.
     * @return {promise} Returns a promise object that will supply the contentArea element as a parameter when it resolves.
     */
    function awaitContentArea(element)
    {
        // Common items that act as content containers
        var contentAreaSelector =
        [
            classes.currentRecordContent.dot(),
            classes.informationPopupTabContainer.dot(),
            classes.contentArea.dot(),
            classes.workflow.dot()
        ].join(",");
        // common items that act as containers within other content containers
        var subContainerSelector =
        [
            classes.dataObjectViewer.dot(),
            classes.workflowContent.dot()
        ].join(",");
        var container = element.closest(contentAreaSelector);
        // We need to search the container for the subContainer, since the dynamicSectionHeader was probably output outside of the subContainer.
        var subContainer = container.find(subContainerSelector);
        var deferred = $.Deferred();

        if (container.length === 0)
        {
            deferred.reject();
        }
        else if (container.hasClass(classes.workflow) && subContainer.children().length === 0)
        {
            container.one("workflow-contentLoaded", function ()
            {
                deferred.resolve(subContainer);
            });
        }
        else if (subContainer.length > 0)
        {
            deferred.resolve(subContainer);
        }
        else
        {
            deferred.resolve(container);
        }

        return deferred.promise();
    }

    /**
     * Insert the section header at the top of the contentArea if the contentArea doesn't have a section header at the top currently.
     * @param {jQuery} dynamicSectionHeader The dynamicSectionHeader to insert.
     * @param {jQuery} contentArea The content area that will receive the section header.
     */
    function addSectionHeaderToContentArea(dynamicSectionHeader, contentArea)
    {
        if (shouldShowSectionHeader(contentArea))
        {
            contentArea.prepend(dynamicSectionHeader);
            dynamicSectionHeader.removeClass(classes.dynamicSectionHeader);
        }
    }

    /**
     * Determines if the dynamic section header should be added to the content area.
     * @param {jQuery} contentArea The content container element that the section header is for.
     * @return {boolean} Returns true if the dynamic section header should be added to the contentArea.
     */
    function shouldShowSectionHeader(contentArea)
    {
        // Items that are either sectionHeaders, or provide sectionHeaders
        var sectionHeaderItemsSelector =
        [
            classes.sectionHeader.dot(),
            classes.browse.dot(),
            classes.childRecordQuickEntry.dot()
        ].join(",");
        // Items that should not appear before a section header.
        // If one of these elements is encountered before a section header element (above), 
        // the dynamic section header will need to be shown.
        var contentItemsSelector =
        [
            ":input",
            classes.title.dot()
        ].join(",");
        // Items to ignore if they appear before a section header.
        var ignoreItemsSelector =
        [
            "[type=hidden]",
            classes.dynamicSectionHeader.dot()
        ].join(",");
        var allItemsSelector = [sectionHeaderItemsSelector, contentItemsSelector].join(",");
        
        var firstSelectorOrContentItem = contentArea.find(allItemsSelector).not(ignoreItemsSelector).first();

        return firstSelectorOrContentItem.is(contentItemsSelector);
    }

    var events =
    {
        init: init
    };

    return events;
});
//# sourceURL=skyward.ui.dynamicSectionHeader.js